import React, { ChangeEvent, FC, Fragment, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';
import { isEqual } from 'lodash';
import {
  Checkbox,
  Grid,
  Paper,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
} from '@material-ui/core';

import { ManualNotificationsItem, ManualNotificationsItemsList } from 'api';

import Row from './Row';

interface IProps extends WithStyles<typeof styles> {
  notificationsList: ManualNotificationsItemsList;
  checkedItem: ManualNotificationsItem;
  onChecked: (event: ChangeEvent<HTMLInputElement>, item: ManualNotificationsItem) => void;
  actions: ReactNode;
  paginator: ReactNode;
}

const styles = (theme: Theme) =>
  createStyles({
    wrapper: {
      minHeight: theme.spacing(4),
      marginBottom: 12,
    },
    block: {
      width: 36,
      height: 36,
    },
  });

const Scheduled: FC<IProps> = props => {
  const { t } = useTranslation();

  const { classes, notificationsList, checkedItem, onChecked, actions, paginator } = props;
  const { items, count } = notificationsList;

  function renderCheckbox(item: ManualNotificationsItem) {
    return (
      <Checkbox checked={isEqual(checkedItem, item)} onChange={event => onChecked(event, item)} />
    );
  }

  return (
    <Fragment>
      <Grid container alignItems="center" justify="space-between" className={classes.wrapper}>
        <Grid item xs={4}>
          <Typography variant="subtitle2">{t('messages:scheduledMessages')}</Typography>
        </Grid>
        <Grid item xs>
          {actions}
        </Grid>
        <Grid item>
          <Typography>{t('components:xResult', { count })}</Typography>
        </Grid>
      </Grid>
      <Paper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell padding="none" style={{ width: 40 }} />
              <TableCell padding="none">
                <Typography noWrap>{t('messages:scheduledFor')}</Typography>
              </TableCell>
              <TableCell />
              <TableCell />
              <TableCell align="center">
                <Typography noWrap>{t('messages:recipients')}</Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map(item => (
              <Row key={item.id} item={item} checkbox={renderCheckbox} />
            ))}
            {!items.length && (
              <TableRow>
                <TableCell padding="none" />
                <TableCell padding="none" colSpan={4}>
                  <em>{t('components:noScheduledMessages')}</em>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        {paginator}
      </Paper>
    </Fragment>
  );
};

export default withStyles(styles)(Scheduled);
